import React from 'react'

import Stack from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'

import { observer } from 'mobx-react-lite'

import { InvestementAllocationList } from './allocation/InvestementAllocationList'
import { InvestementsAllocationChart } from './allocation/InvestmentsAllocationChart'
import { createInvestmentsAllocationData } from './allocation/util/createInvestementsAllocationData'
import {
  useAccountStore,
  useGlobalCopyStore,
  useGlobalUiStore,
  useHoldingStore,
  useScreenSize,
} from '../../common'

const Allocation = () => {
  const [selectedTabs, setSelectedTabs] = React.useState(0)
  const [selectedId, setSelectedId] = React.useState('')
  const [hoveredId, setHoveredId] = React.useState('')
  const onSelected = (id: string) => {
    if (selectedId !== id) {
      setSelectedId(id)
    } else {
      setSelectedId('')
      setHoveredId('')
    }
  }
  const { selectedAccountGuids } = useGlobalUiStore()
  const { visibleHoldings: allHoldings } = useHoldingStore()
  const { visibleInvestmentAccounts: accounts } = useAccountStore()
  const {
    investments: { allocation: copy },
  } = useGlobalCopyStore()
  const investmentAllocationData = createInvestmentsAllocationData(
    accounts.filter(({ guid }) => selectedAccountGuids.includes(guid)),
    copy,
    allHoldings,
  )
  const { isMobile } = useScreenSize()
  const isScreenDeviceTablet = useMediaQuery('(max-width:768px)')

  return (
    <Stack
      alignItems={isScreenDeviceTablet ? 'center' : 'flex-start'}
      direction={isScreenDeviceTablet ? 'column' : 'row'}
      gap={{ xs: 16, md: 64, xl: 100 }}
      sx={{
        justifyContent: 'center',
        mt: 50,
        width: '100%',
      }}
    >
      <InvestementsAllocationChart
        data={investmentAllocationData}
        hoveredId={hoveredId}
        isPercentage={selectedTabs === 1}
        onMouseEnter={(id) => {
          if (selectedId === id) {
            setHoveredId('')
          } else if (!selectedId) {
            setHoveredId(id)
          }
        }}
        onMouseLeave={() => {
          setHoveredId('')
        }}
        onSelected={onSelected}
        selectedId={selectedId}
        size={isMobile ? 280 : 400}
        totalLabel={copy.pie_chart_centered_text}
      />
      <InvestementAllocationList
        data={investmentAllocationData}
        onSelected={onSelected}
        selectedId={selectedId}
        selectedTabs={selectedTabs}
        setSelectedTabs={setSelectedTabs}
      />
    </Stack>
  )
}

export default observer(Allocation)
